import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zh from "./locales/zh.json";
import en from "./locales/en.json";

const STORAGE_KEY = "capture_language";

// localStorage can throw (not just return null) in some mobile browser
// privacy modes (e.g. iOS Safari private browsing / strict tracking
// prevention) - this file runs at module-load time before anything else,
// so an uncaught throw here would blank out the entire app before React
// even mounts. Guard both directions defensively.
function getStoredLanguage() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

i18n.use(initReactI18next).init({
  resources: { zh: { translation: zh }, en: { translation: en } },
  lng: getStoredLanguage() || "zh",
  fallbackLng: "zh",
  interpolation: { escapeValue: false },
});

// AI-generated capture titles need to know the current UI language too
// (backend generates English titles when the UI is in English, regardless
// of the captured content's own language) - persisted alongside the i18n
// choice so useCaptureUpload can read it when posting.
i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // ignore - language preference just won't persist across sessions
  }
});

export default i18n;
